import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=6bb90f9f&scoped=true"
import script from "./formItem.vue?vue&type=script&lang=js"
export * from "./formItem.vue?vue&type=script&lang=js"
import style0 from "./formItem.vue?vue&type=style&index=0&id=6bb90f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb90f9f",
  null
  
)

export default component.exports